import { Types } from './actionTypes';

export const ActionCreators = {
  login: (user) => ({ type: Types.LOGIN, payload: { user } }),
  logout: (user) => ({ type: Types.LOGOUT, payload: { user } }),
  selectCompany: (company) => ({ type: Types.SELECT_COMPANY, payload: { company } }),
  changeCompany: () => ({ type: Types.CHANGE_COMPANY }), 
}